module.exports = __webpack_public_path__ + "static/media/debut_album.b2060503.png";